import styled from 'styled-components';
import palette from 'lib/styles/palette';
import useDashboardCount from 'hooks/common/useDashboardCount';
import { useLocation, useNavigate, Outlet, Link } from 'react-router-dom';
import { useEffect } from 'react';
import ErrorNoti from 'components/common/ErrorNoti';
import Loading from 'components/common/Loading';

const DashboardViewer = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { isLoading, error, dashboardCounts } = useDashboardCount();

  useEffect(() => {
    if (pathname === '/admin') navigate('/admin/dashboard/place');
  }, [pathname, navigate]);

  if (isLoading) return <Loading />;
  if (error?.response.statue === 500) return <ErrorNoti />;

  return (
    <DashboardViewerBlock>
      <div className="title">대시보드</div>
      <div className="subtitle">계약 진행 상황</div>
      <div className="box">
        <div className="board-header">
          <div className="board-header-col">장소 등록 대기</div>
          <div className="board-header-col">장비 등록 대기</div>
        </div>
        <div className="board-row">
          <Link to="/admin/dashboard/place">{dashboardCounts?.storeCount}</Link>
          <Link to="/admin/dashboard/device">
            {dashboardCounts?.deviceCount}
          </Link>
        </div>
      </div>
      <Outlet />
    </DashboardViewerBlock>
  );
};

export default DashboardViewer;

const DashboardViewerBlock = styled.div`
  width: 768px;
  margin: 0 auto;

  .title {
    margin-top: 2rem;
    font-weight: bold;
    font-size: 1.4rem;
  }

  .subtitle {
    margin-top: 2rem;
    font-size: 1.1rem;
    font-weight: bold;
  }

  .box {
    margin-top: 1rem;
    padding: 0 30px;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.1);
  }

  .board-header {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    font-weight: 500;
  }

  .board-header-col {
    width: 100%;
    text-align: center;
  }

  .board-row {
    margin: 20px 0 30px 0;
    display: flex;
    justify-content: center;
    font-size: 1.3rem;
    text-decoration: underline;
    font-weight: 600;
  }

  a {
    width: 100%;
    text-align: center;
    cursor: pointer;
    &:hover {
      color: ${palette.theme[3]};
    }
  }
`;
